import script from "./address-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./address-table.vue?vue&type=script&setup=true&lang=ts"

import "./address-table.vue?vue&type=style&index=0&id=db5c8cde&lang=scss"

const __exports__ = script;

export default __exports__